import React, { useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";
import * as chatGPTReducer from "@/containers/ChatGPT/reducer";
import * as aibleAnywhereReducer from "@/containers/AibleAnywhere/reducer";
import * as chatDetailsReducer from "@/containers/ChatDetails/reducer";
import { CHAT_MARKDOWN_OVERRIDES } from "@/containers/ChatGPT/reducer";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import MarkdownPanel from "../ChatGPT/MarkdownPanel";
const AiqView = ({ match, agentIdOverride }) => {
    const dispatch = useDispatch();
    const agentId = agentIdOverride !== undefined ? agentIdOverride : match?.params?.agentId;
    const aiqAgent = useSelector((state) => aibleAnywhereReducer.getAibleAnywhere(state, agentId));
    const aiqDetail = useSelector((state) => chatDetailsReducer.getChatMessageDetails(state, aiqAgent?.aiqExecutionId));
    const aiqIsNotComplete = aiqDetail && (aiqDetail?.status === "RUNNING" || aiqDetail?.status === "NOT_STARTED");
    const aiqHasFailed = (aiqDetail && aiqDetail?.status === "ERROR") || aiqDetail?.status === "FAILED";
    const initHelper = async () => {
        try {
            await dispatch(aibleAnywhereReducer.initAiq(agentId));
            await dispatch(chatGPTReducer.init(true));
        }
        catch (e) {
            console.log(e);
        }
        dispatch(chatGPTReducer.updateAgentId(agentId));
    };
    useEffect(() => {
        initHelper();
    }, []);
    useEffect(() => {
        if (aiqIsNotComplete) {
            dispatch(chatGPTReducer.pollStreamingExecution(aiqAgent?.aiqExecutionId, 10000, true));
        }
    });
    // Rendering when agent is loading or job still in progress
    if (!aiqAgent || aiqIsNotComplete) {
        return (React.createElement("div", { className: styles.aiqViewWrapper, style: { justifyContent: "center", alignItems: "center" } },
            React.createElement(LoadingIndicator, null),
            React.createElement("div", null, aiqIsNotComplete ? "Deep Research in progress..." : "Loading Agent...")));
    }
    // Rendering of a failed job
    if (aiqHasFailed) {
        return (React.createElement("div", { className: styles.aiqViewWrapper },
            React.createElement("div", { className: styles.aiqViewBody },
                React.createElement("div", { className: styles.aiqViewContent },
                    React.createElement("div", { className: styles.aiqViewContentHeader }, `${aiqAgent?.name} Results:`),
                    React.createElement("div", { className: styles.aiqViewContentBodyWrapper },
                        React.createElement("div", { className: styles.aiqViewContentBody },
                            React.createElement("div", { className: "font-bold" }, "There was an error completing this deep research")))))));
    }
    // Render the results when they're ready
    if (aiqDetail?.results?.length) {
        return (React.createElement("div", { className: styles.aiqViewWrapper },
            React.createElement("div", { className: styles.aiqViewBody },
                React.createElement("div", { className: styles.aiqViewContent },
                    React.createElement("div", { className: styles.aiqViewContentHeader }, `${aiqAgent?.name} Results:`),
                    React.createElement("div", { className: styles.aiqViewContentBodyWrapper },
                        React.createElement("div", { className: styles.aiqViewContentBody }, aiqDetail?.results?.map((result) => (React.createElement(MarkdownPanel, { overrides: CHAT_MARKDOWN_OVERRIDES }, result?.data?.output?.content)))))))));
    }
    // Rendered by default while states could still be updating
    return (React.createElement("div", { className: styles.aiqViewWrapper, style: { justifyContent: "center", alignItems: "center" } },
        React.createElement(LoadingIndicator, null),
        React.createElement("div", null, "Loading...")));
};
export default AiqView;
